// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QpVD3qAS0nYBtoQqAYoe {
  padding: 0.5rem;
  margin: 0;
  background-color: rgb(65, 64, 64);
  color: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom: 2px solid black;
}
.QpVD3qAS0nYBtoQqAYoe .sUMBkZuJ9OR9j2qXysM4 {
  width: 3rem;
}
.QpVD3qAS0nYBtoQqAYoe .sUMBkZuJ9OR9j2qXysM4:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/NavBar/NavBar.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,SAAA;EACA,iCAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AAAI;EACI,WAAA;AAER;AAAI;EACI,eAAA;AAER","sourcesContent":[".NavBar {\n    padding: .5rem;\n    margin: 0;\n    background-color: rgb(65, 64, 64);\n    color: white;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    border-bottom: 2px solid black;\n    .icon {\n        width: 3rem;\n    }\n    .icon:hover {\n        cursor: pointer;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NavBar": `QpVD3qAS0nYBtoQqAYoe`,
	"icon": `sUMBkZuJ9OR9j2qXysM4`
};
export default ___CSS_LOADER_EXPORT___;
